document.addEventListener('DOMContentLoaded', () => {
  const slider = document.querySelector('.slider');

  if (!slider) return;

  let startX = 0;

  slider.addEventListener('pointerdown', (e) => {
    startX = e.clientX;
    slider.setPointerCapture(e.pointerId);
  });

  slider.addEventListener('pointerup', (e) => {
    const diff = e.clientX - startX;

    if (Math.abs(diff) < 40) return;

    const container = slider.closest('.slider-component');
    if (!container) return;

    const next = container.querySelector('button[name="next"]');
    const prev = container.querySelector('button[name="previous"]');

    if (diff < 0 && next) next.click();
    if (diff > 0 && prev) prev.click();
  });
});

